import { NumberInput as MantineNumberInput, type NumberInputProps as MantineNumberInputProps } from '@mantine/core'
import { type FC } from 'react'

export interface NumberInputProps extends MantineNumberInputProps {}

export const NumberInput: FC<NumberInputProps> = (props) => (
  <MantineNumberInput
    mb='xs'
    radius='md'
    {...props}
  />
)
